import { action, observable } from 'mobx'
import { message } from 'hljd'
import { INPUT_ID, SELECT_ID } from '../Create/VrForm/constant'
import { isHotelMerchant } from '@util'
import vrStore from '../store'
import api from '@api/vr'

class Store {
  @observable panoId = '' // 全景组id
  @observable hotelVrInfo = {} // 全景信息
  @observable hallList = [] // 酒店商家场地列表

  // 获取全景信息
  @action
  getPanoInfo = async () => {
    const { data } = await api.getPano({
      id: this.panoId
    })
    this.hotelVrInfo = data
    localStorage.setItem('merchant_logo', this.hotelVrInfo.merchant_logo || '')
  }
  // 酒店商家获取场地列表
  @action
  getHallList = async () => {
    const {
      data: { list }
    } = await api.sitelist({
      status: 1,
      is_published: 1
    })
    list.unshift({
      id: '',
      name: '请选择场地'
    })
    this.hallList = list
  }
  // 保存基础信息
  @action
  onBasicSave = async getFieldsValue => {
    const isHotelM = isHotelMerchant()
    const values = getFieldsValue([SELECT_ID, INPUT_ID])
    if (!values[INPUT_ID]) {
      message.error('请完善后再次提交！')
      return false
    }
    const params = {
      name: values[INPUT_ID],
      panoId: this.panoId,
      cover: this.hotelVrInfo.cover
    }
    if (isHotelM) {
      params['hotelHallId'] = values[SELECT_ID] || ''
    }
    const { success, RetCode } = await api.postPanoEdit(params)
    if (success) {
      vrStore.isUnsave = false
      message.success('保存成功')
    }
    return RetCode
  }

  @action
  updateCoverImg = coverImg => {
    this.hotelVrInfo.cover = coverImg
  }
}

export default new Store()
